import { ADD_TICKET, ADD_TICKET_FAILED, ADD_TICKET_SUCCESS, TICKET, TICKET_FAILED, TICKET_SUCCESS, UPDATE_TICKET, UPDATE_TICKET_FAILED, UPDATE_TICKET_SUCCESS } from "./actionTypes"

let initialState = {
    ticket: [],
    addTicket: "",
    updateTicket: "",
    loading: false,
    success: false,
    error: ''
}

export const ticketReducer = (state = initialState, action) => {
    switch (action.type) {

        case TICKET: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case TICKET_SUCCESS: return {
            ...state,
            ticket: action.payload,
            loading: false,
            success: true
        }
        case TICKET_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TICKET: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TICKET_SUCCESS: return {
            ...state,
            addTicket: action.payload,
            ticket: [...state.ticket, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TICKET_FAILED: return {
            ...state,
            addTicket: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_TICKET: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_TICKET_SUCCESS: return {
            ...state,
            updateTicket: action.payload,
            ticket: state.ticket.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_TICKET_FAILED: return {
            ...state,
            updateTicket: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}